import { useState } from "react";
import { toast } from "sonner";
import { Check, Loader2 } from "lucide-react";
import { PRICES, startCheckout, formatApiError } from "@/lib/api";

export const BuyBox = ({ idPrefix = "buy", align = "left" }) => {
  const [selected, setSelected] = useState("oneTime");
  const [loading, setLoading] = useState(false);

  const option = PRICES[selected];

  const handleCheckout = async () => {
    setLoading(true);
    try {
      await startCheckout(option.key);
    } catch (e) {
      toast.error(formatApiError(e));
      setLoading(false);
    }
  };

  return (
    <div className={align === "center" ? "mx-auto max-w-md" : "max-w-md"} data-testid={`${idPrefix}-buy-box`}>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <button
          type="button"
          data-testid={`${idPrefix}-option-onetime`}
          onClick={() => setSelected("oneTime")}
          className={`relative text-left rounded-2xl border p-4 transition-[border-color,background-color,box-shadow] duration-300 ${
            selected === "oneTime"
              ? "border-gold bg-white shadow-[0_8px_30px_rgb(201,162,39,0.12)]"
              : "border-gold-light/60 bg-white/60 hover:border-gold-light"
          }`}
        >
          <div className="flex items-center justify-between">
            <span className="text-[11px] font-semibold tracking-[0.14em] uppercase text-[#8C8C8C]">One-Time Purchase</span>
            {selected === "oneTime" && <Check size={16} className="text-gold-deep" strokeWidth={2.5} />}
          </div>
          <div className="mt-2 font-display text-3xl text-ink">£19.99</div>
          <div className="mt-1 text-xs text-[#8C8C8C]">60 patches · single delivery</div>
        </button>
        <button
          type="button"
          data-testid={`${idPrefix}-option-subscription`}
          onClick={() => setSelected("subscription")}
          className={`relative text-left rounded-2xl border p-4 transition-[border-color,background-color,box-shadow] duration-300 ${
            selected === "subscription"
              ? "border-gold bg-white shadow-[0_8px_30px_rgb(201,162,39,0.12)]"
              : "border-gold-light/60 bg-white/60 hover:border-gold-light"
          }`}
        >
          <span className="absolute -top-2.5 right-3 rounded-full bg-gold text-white text-[10px] font-bold tracking-wider px-2.5 py-0.5">
            SAVE 25%
          </span>
          <div className="flex items-center justify-between">
            <span className="text-[11px] font-semibold tracking-[0.14em] uppercase text-[#8C8C8C]">Subscribe &amp; Save</span>
            {selected === "subscription" && <Check size={16} className="text-gold-deep" strokeWidth={2.5} />}
          </div>
          <div className="mt-2 font-display text-3xl text-ink">
            £14.99<span className="text-base text-[#8C8C8C]">/mo</span>
          </div>
          <div className="mt-1 text-xs text-[#8C8C8C]">Monthly delivery · cancel anytime</div>
        </button>
      </div>
      <button
        type="button"
        data-testid={`${idPrefix}-shop-now-btn`}
        onClick={handleCheckout}
        disabled={loading}
        className="group mt-4 w-full inline-flex items-center justify-center gap-2 rounded-full bg-ink text-white font-semibold tracking-wide px-8 py-4 text-base hover:bg-gold-deep transition-colors duration-300 disabled:opacity-70"
      >
        {loading ? (
          <Loader2 size={18} className="animate-spin" />
        ) : (
          <>SHOP NOW — {option.amount}{selected === "subscription" ? "/mo" : ""}</>
        )}
      </button>
      <p className="mt-3 text-[11px] text-[#8C8C8C] text-center tracking-wide" data-testid={`${idPrefix}-secure-note`}>
        Secure checkout · 60 hydrogel eye patches per pack
      </p>
    </div>
  );
};
